import { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

interface DateProp {
  label: string;
  value: string | any; // value should be required for controlled component
  handleDate: (date: any | null) => void; // define type for handleDate
}

const CustomDatePicker = (props: DateProp) => {
  const { label, value, handleDate } = props;

  const dateValue = value ? dayjs(value) : null;

  // Use local state to manage the value
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(
    dateValue
  );

  // Re-sync when the parent changes `value` after mount (e.g. form reset or an
  // async record load). Without this, a PHI date field (DOB, specimen dates)
  // would keep showing the stale mount-time value. Keyed on the timestamp so a
  // fresh dayjs instance representing the same date does not churn state.
  const valueKey = dateValue ? dateValue.valueOf() : null;
  useEffect(() => {
    setSelectedDate(value ? dayjs(value) : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueKey]);

  const handleChange = (date: dayjs.Dayjs | null) => {
    setSelectedDate(date); // Update local state
    handleDate(date); // Call the handler passed from parent
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        slotProps={{
          textField: {
            fullWidth: true,
          },
        }}
        value={selectedDate ? dayjs(selectedDate) : null} // Pass selectedDate as value
        onChange={handleChange} // Use handleChange instead of handleDate directly
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
